import { useContext } from "react";
import { Contex } from "../kzContex";
import { Link } from "react-router-dom";

const CategoryCard = ({ categories, activeTab }) => {
    const { searchTerm, isLoading } = useContext(Contex);
    
    // Use categories from props if available, otherwise fallback to context
    const displayCategories = categories || [];

    if (isLoading) return null;

    return(
        <div className="container category my-5">
            <div className="title-wrapper d-flex align-items-center mb-4">
                <h6 className="txtTopUp mb-0">
                    Top Up {activeTab === 'game' ? 'Games' : 'Vouchers'}
                </h6>
            </div>
            <div className="row my-4">
                { displayCategories.length > 0 ? (
                    displayCategories.map((c) => {
                        return(
                            <div key={c.id} className="col-lg-2 col-md-3 col-xl-2 col-sm-4 col-4 position-relative">
                                { (c.description.includes('Mobile Legends') || c.description.includes('Free Fire')) && (
                                    <div className="promo-badge">PROMO</div>
                                )}
                                <Link to={`/game/${encodeURIComponent(c.description)}`} style={{ textDecoration: 'none' }}>
                                    <div className="card-category-new w-100 my-2">
                                        <div className="card-category-img-container">
                                            <img src={c.image} className="card-category-img" alt={c.description}/>
                                            <div className="card-category-img-overlay">
                                                <span>{c.developer?.toUpperCase()}</span>
                                            </div>
                                        </div>
                                        <div className="card-category-info mt-3 px-1">
                                            <div className="card-category-title">{c.description}</div>
                                            <div className="card-category-subtitle">{c.developer}</div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        )
                    })
                ) : (
                    <div className="col-12 text-center py-5">
                        <i className="bi bi-search text-muted mb-3" style={{ fontSize: '2rem' }}></i>
                        <p className="text-muted">Produk "{searchTerm}" tidak ditemukan di kategori {activeTab}s.</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default CategoryCard;